import React from 'react';
import FlightSearchPage from "../FlightSearchPage";

const EditPermanentBooking = (props) => {
    return (
        <FlightSearchPage 
            {...props}
            isMultipleBookingEdit 
            disableBeforeClosePrompt 
        />
    );
};

export default EditPermanentBooking;